interface UploaderFile extends File {
  id: string;
}

export default UploaderFile;
